export default __webpack_public_path__ + "static/media/ys5.5f7a89b6.jpg";